import { render } from "./TheAdminResourcesGrid.vue?vue&type=template&id=042b0759&scoped=true&ts=true"
import script from "./TheAdminResourcesGrid.vue?vue&type=script&lang=ts"
export * from "./TheAdminResourcesGrid.vue?vue&type=script&lang=ts"

import "./TheAdminResourcesGrid.vue?vue&type=style&index=0&id=042b0759&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042b0759"]])

export default __exports__